import {Brick, registerBrick, Color} from 'olympe';
import React, {useState} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import Button from '@mui/material/Button';
import {ezprOrange} from '../_helpers';
import Tooltip from '@mui/material/Tooltip';

/**
 * Brick that display a simple popup (mui component)
 */
export default class ShowNewVersionAvailable extends Brick {
    /**
     * Executed every time the brick receives a new trigger event.
     * Note that the method will be executed _even if_ an input (title, text, color, icon) is undefined.
     *
     * @protected
     * @param {BrickContext} context
     * @param {string} title
     * @param {string} text
     * @param {Color} color
     * @param {string} icon
     * @param {function()} forwardEvent
     */
    update(context, [], [forwardEvent, refresh]) {
        const popupId = 'popup019223cf12256238d293';
        if (!document.getElementById(popupId)) {
            const head = document.body;
            const popup = document.createElement('div');
            popup.id = popupId;
            head.appendChild(popup);
        }

        ReactDOM.render((<ShowNewVersionAvailable.Component
            forwardEvent={forwardEvent}
            refresh={refresh}
        />), document.getElementById(popupId));
    }
}

/**
 * @param {Object} props
 * @param {string} props.title
 * @param {string} props.text
 * @param {BrickContext} props.context
 * @param {Color} props.color
 * @param {function()} props.forwardEvent
 * @return {JSX.Element}
 * @constructor
 */
ShowNewVersionAvailable.Component = (props) => {
    const [open, setOpen] = useState(true);

    const handleClose = () => {
        setOpen(false);
        document.getElementById('popup019223cf12256238d293').remove();
        props.forwardEvent();
    };

    const handleRefresh = () => {
        props.refresh();
        handleClose();
    };

    return (
        <Dialog
            onClose={handleClose}
            open={open}
            aria-labelledby="popup-title"
            style={{flexDirection: 'row'}}
        >
            <div style={{display: 'flex'}}>
                <div style={{backgroundColor: ezprOrange, width: '20%', height: 'auto', display: 'flex', alignItems: 'center', minWidth: '50px', justifyContent: 'center'}}>
                    <i className="material-icons" style={{color: 'white'}}>{'start'}</i>
                </div>
                <div>
                    <DialogTitle id="popup-title">{'A new version of Easy Request is available'}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="popup-description">
                            {'Easy Request has been upgraded in the background.'}
                        </DialogContentText>
                        <DialogContentText id="popup-description">
                            {'If you have unsaved modification, you can close this popup and continue using this version. Otherwise, use the refresh button to start using the new version right now.'}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Tooltip title={'Ignore the new version for now and continue working on this page.'} placement={'top'}>
                            <Button onClick={handleClose}>
                                Close
                            </Button>
                        </Tooltip>
                        <Tooltip title={'Click to reload this page and start using the new version right now.'} placement={'top'}>
                            <Button onClick={handleRefresh}>
                            Refresh
                            </Button>
                        </Tooltip>
                    </DialogActions>
                </div>
            </div>

        </Dialog>
    );
};

ShowNewVersionAvailable.Component.propTypes = {
    forwardEvent: PropTypes.func,
    refresh: PropTypes.func,
};

registerBrick('019223cf12256238d293', ShowNewVersionAvailable);
